import React, {
  Suspense,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { AnimatePresence, motion, useCycle } from "framer-motion";
import { IoCloseSharp } from "react-icons/io5";
import { HiMenuAlt1 } from "react-icons/hi";
import { Link } from "react-router-dom";

import MenuContext from "./MenuContext";
import MobileMenuChild from "./components/MobileMenuChild";
import ItemMobile from "./components/ItemMobile";
import Color from "../../context/constants/Color";
import styles from "./SSoft_Header.module.css";
import Expand from "./assets/Expand";
import * as Popover from "@radix-ui/react-popover";
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import en from "./assets/en.svg";

const itemVariants = {
  closed: { opacity: 0 },
  open: { opacity: 1 },
};

const sideVariants = {
  closed: {
    transition: {
      staggerChildren: 0,
      staggerDirection: -1,
      duration: 0.1,
      delay: 0.1,
    },
  },
  open: {
    transition: {
      staggerChildren: 0.2,
      duration: 0.2,
      staggerDirection: 1,
    },
  },
};

export default function MobileMenu() {
  const menuContext = useContext(MenuContext);
  const dispatch = useDispatch();
  const { data, menu, isSearch } = menuContext;
  const languages = [
    {
      abbreviation: "en",
      flag: "GB",
      id: 1,
      is_default: true,
      name: "English",
    },
    {
      id: 3,
      abbreviation: "id",
      flag: "ID",
      name: "Indonesian",
      is_default: false,
    },
  ];
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const langElementActive = languages.filter(
    (lang) => lang.id === activeLanguage
  );

  const [open, cycleOpen] = useCycle(false, true);
  const [activeItem, setActiveItem] = useState(false);
  const [pagination, setPagination] = useState(["Home"]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeFill, setActiveFill] = useState(Color.white);
  const [isScrolling, setIsScrolling] = useState(false);

  const prevOpenRef = useRef();

  const isScrollActive = activeFill === Color.blackPrimary;
  const bgContainer = Color.white;
  const mainVariants = {
    // initial: () => ({ opacity: 1 }),
    open: () => ({
      width: "100vw",
      opacity: 1,
      zIndex: open ? "-1" : 10000,
      top: 0,
      // position: open ? 'absolute' : 'relative',
      backgroundColor: open ? "transparent" : bgContainer,
      transition: { delay: open ? 0 : 0, duration: 0.3 },
    }),
    // closed: () => ({ transition: { delay: 0.3, duration: 0.3 } }),
  };

  useEffect(() => {
    prevOpenRef.current = open;
    if (prevOpenRef.current !== open) {
      setActiveItem(false);
      setPagination(["Home"]);
    }
  }, [open]);

  const handleClickLang = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const openLang = Boolean(anchorEl);
  const id = openLang ? "simple-popover" : undefined;

  useEffect(() => {
    if ((data && isScrolling) || (data && isSearch)) {
      setTimeout(() => {
        setActiveFill(Color.blackPrimary);
      }, 100);

      return () => {
        clearTimeout();
      };
    }
  }, [isScrolling, data, isSearch]);

  useEffect(() => {
    if (
      !isScrolling &&
      data &&
      activeFill === Color.blackPrimary &&
      !isSearch
    ) {
      setTimeout(() => {
        setActiveFill(Color.white);
      }, 100);

      return () => {
        clearTimeout();
      };
    }
  }, [isScrolling, data, activeItem, activeFill, isSearch]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0 && !isScrolling) {
        setIsScrolling(true);
      }
      if (window.scrollY === 0) {
        setIsScrolling(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolling]);

  return (
    <Suspense fallback={<div className="flex"></div>}>
      <AnimatePresence>
        {open && (
          <motion.aside
            className="z-[10001] fixed xl:!hidden !block p-5 "
            initial={{ width: 0, right: "-100%", opacity: 0 }}
            animate={{ width: "100%", right: 0, opacity: 1, top: 0 }}
            exit={{
              right: "-100%",
              opacity: 0,
              width: 0,
              transition: { delay: 0.3, duration: 0.3 },
            }}
          >
            <motion.div
              className=" rounded-xl border bg-white xl:!hidden !block"
              initial="closed"
              animate="open"
              exit="closed"
              variants={sideVariants}
            >
              <div className="w-full h-fit overflow-auto py-4 px-8 flex flex-col">
                <div className="flex justify-between mb-4">
                  <motion.div variants={itemVariants}>
                    <Link to="/">
                      <div className="flex items-center w-[96px]">
                        <img
                          src={data?.logo[0]?.file}
                          className=""
                          alt="super logo"
                        />
                      </div>
                    </Link>
                  </motion.div>

                  <button className="fixed right-8" onClick={cycleOpen}>
                    <IoCloseSharp className="w-8 h-8" />
                  </button>
                </div>

                <div className="w-full  relative">
                  {menu?.map((itm) => (
                    <motion.li
                      key={itm.id}
                      className=" pr-4  items-center  border-opacity-30 list-none"
                    >
                      <ItemMobile itm={itm} closeMenu={cycleOpen} />
                      <div className="flex flex-col space-y-3 mt-2 ">
                        {itm.children?.length > 0 && (
                          <MobileMenuChild
                            item={itm}
                            title={itm.title}
                            goBack={() => {
                              setActiveItem(false);
                              setPagination(
                                pagination.filter((e) => e !== itm.title)
                              );
                            }}
                            setPagination={setPagination}
                            pagination={pagination}
                            closeMenu={cycleOpen}
                          />
                        )}
                      </div>
                    </motion.li>
                  ))}
                </div>
                <Link
                  to={data?.language[0]?.article_language?.path || "/"}
                  className=""
                >
                  <div className="bg-[#255262] flex items-center justify-center text-white rounded-[8px] w-full  text-[16px] font-inter h-[49px] px-[20px] mt-[45px] text-center">
                    {data?.language[0]?.article_language?.title}
                  </div>
                </Link>
              </div>
            </motion.div>
          </motion.aside>
        )}
      </AnimatePresence>
      <motion.div
        className={[
          "fixed top-0  h-full max-h-[80px] xl:!hidden !block",
          styles.mContainer,
        ].join(" ")}
        initial="initial"
        animate="open"
        exit="closed"
        variants={mainVariants}
      >
        <div className="w-full h-full py-5 section-container  flex justify-between items-center">
          <motion.div variants={itemVariants}>
            <Link to="/">
              <div className="flex items-center ws-[206px]">
                <img
                  src={data?.logo[0]?.file}
                  className=" w-full h-[50px]"
                  alt="supersoft logo"
                />
              </div>
            </Link>
          </motion.div>

          <motion.div
            className="flex items-center space-x-4"
            variants={itemVariants}
          >
            <Popover.Root>
              <Popover.Trigger asChild>
                <button className="flex items-center cursor-pointer">
                  {/* <div className="">{langElementActive[0].flag}</div> */}
                  <img
                    src={
                      activeLanguage !== 1
                        ? data?.lang_icon[1]?.file
                        : data?.lang_icon[0]?.file
                    }
                    alt=""
                    className="rounded-full w-4 h-4 shadow"
                  />
                  <div className="mr-[12px] ml-[9px]">
                    {activeLanguage === 1 ? "EN" : "ID"}
                  </div>
                  <Expand fill="#000000" className="" />
                </button>
              </Popover.Trigger>
              <Popover.Portal>
                <Popover.Content className="PopoverContent" sideOffset={5}>
                  <div className="flex py-2 px-4">
                    <div className="flex flex-col space-y-2 items-start">
                      {languages.map((l) => {
                        const isActive =
                          activeLanguage && l.id === activeLanguage;
                        const activeStyle = isActive
                          ? "text-black font-semibold"
                          : "text-black";
                        return (
                          <button
                            key={l.name}
                            onClick={() => {
                              if (window.location.hash) {
                                window.history.replaceState(
                                  "",
                                  document.title,
                                  window.location.pathname
                                );
                              }
                              if (!isActive) {
                                dispatch({
                                  type: "content/setActiveLanguage",
                                  payload: l,
                                });
                              }
                            }}
                          >
                            <div
                              className={[
                                activeStyle,
                                "cursor-pointer  flex items-center space-x-2",
                              ].join(" ")}
                            >
                              <img
                                src={
                                  l.id !== 1
                                    ? data?.lang_icon[1]?.file
                                    : data?.lang_icon[0]?.file
                                }
                                alt=""
                                className="rounded-full w-4 h-4 shadow"
                              />
                              <span className="hover:text-[#E12726]  border-b-2 border-white hover:border-[#E12726] transition-all">
                                {l.name}
                              </span>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <Popover.Close className="PopoverClose" aria-label="Close">
                    <MdClose />
                  </Popover.Close>
                  <Popover.Arrow className="PopoverArrow" />
                </Popover.Content>
              </Popover.Portal>
            </Popover.Root>
            <button onClick={cycleOpen} className="w-8 h-8">
              <HiMenuAlt1
                fontSize="32"
                sx={{ width: 32, height: 32, color: "black" }}
              />
            </button>
          </motion.div>
        </div>
      </motion.div>
    </Suspense>
  );
}
